import { cn } from "@/lib/utils/cn";

export interface StepProgressItem {
  id: string;
  title: string;
}

interface StepProgressProps {
  steps: readonly StepProgressItem[];
  currentStep: number;
  className?: string;
}

export const StepProgress = ({
  steps,
  currentStep,
  className,
}: StepProgressProps) => {
  return (
    <div className={cn("w-full", className)}>
      <div className="flex w-full items-start">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          return (
            <div
              key={step.id}
              className={cn(
                "flex min-w-0 flex-1 items-start",
                index === steps.length - 1 && "flex-none",
              )}
            >
              <div className="flex min-w-0 flex-col items-center text-center">
                <div
                  className={cn(
                    "flex h-9 w-9 items-center justify-center rounded-full border text-sm font-medium",
                    isCurrent || isCompleted
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border bg-muted text-muted-foreground",
                  )}
                >
                  {index + 1}
                </div>
                <span
                  className={cn(
                    "mt-2 text-sm font-medium whitespace-nowrap",
                    isCurrent || isCompleted
                      ? "text-foreground"
                      : "text-muted-foreground",
                  )}
                >
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className="bg-border mx-4 mt-4 h-px min-w-8 flex-1" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
